<template>
  <div ref="accordion" :class="_containerCss">
    <cat-accordian-box
      v-for="item in items"
      :id="item.id"
      :key="item.id"
      :title="item.title"
      :open="item.id === selected"
      :visited="item.visited"
      :completed="!item.visited || item.complete"
      :errors="item.errors"
      :incompleteText="resolveTxt('incomplete')"
      :nextid="item.nextid"
      :hint="item.node && item.node.text && item.node.text.hint"
      :help="item.help"
      :titleLevel="titleLevel"
      @ui-next="onNext"
      @ui-select="onSelect"
      @ui-focus-previous="focusBoxPrevious"
      @ui-focus-next="focusBoxNext"
      @ui-updated="onUpdated"
    >
      <slot :name="item.id"></slot>
    </cat-accordian-box>
  </div>
</template>
<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";
import CatAccordianBox from "@/components/layouts/accordian-box.vue";
import jQuery from "jquery";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);

    return {
      resolveTxt
    };
  },
  name: "CatAccordian",
  components: {
    CatAccordianBox
  },
  props: {
    title: {
      type: [String],
      description: "Accordion title"
    },
    id: {
      type: [String, Number],
      description: "Accordion id"
    },
    items: {
      type: [Array],
      description: "This list of all items in the accordion"
    },
    selected: {
      type: [String, Number],
      description: "The node id of the expanded accordion panel"
    },
    titleLevel: {
      type: [Number],
      description: "Accordion section title level",
      default: 3
    },
    progress: {
      type: Boolean,
      default: false,
      description: "Display whether accordion section has been completed."
    },
    boxed: {
      type: Boolean,
      default: false,
      description:
        "Boxed and bordered design, white background and light borders with CSS shadows."
    }
  },
  watch: {
    selected: function (newsel) {
      // Focus on the accordion heading link button when expanding a new accordion
      this.$nextTick(function () {
        jQuery(
          "[role=heading] > [role=button][aria-expanded=true]",
          this.$refs.accordion
        )
          .first()
          .focus();
      });
    }
  },
  computed: {
    _containerCss: function () {
      return {
        "cat-acc-content cat-accordion": true,
        boxed: this.boxed,
        "accordion-progress": this.progress
      };
    }
  },
  methods: {
    onNext: function (evt) {
      this.$emit("ui-next", {
        id: evt.id
      });
    },
    onSelect: function (evt) {
      this.$emit("ui-select", {
        id: evt.id
      });
    },
    onUpdated: function (evt) {
      this.$emit("ui-updated", {
        id: evt.id
      });
    },
    focusBoxPrevious: function (evt) {
      let index = this.getAccordionBoxIndex(evt.id);

      // When focus is on first accordion header, moves focus to last accordion header.
      // When focus is on an accordion header, moves focus to the previous accordion header.
      let accordionId =
        index <= 0
          ? this.items[this.items.length - 1].id
          : this.items[index - 1].id;
      this.focusAccordion(accordionId);
    },
    focusBoxNext: function (evt) {
      let index = this.getAccordionBoxIndex(evt.id);

      // When focus is on last accordion header, moves focus to first accordion header.
      // When focus is on an accordion header, moves focus to the next accordion header.
      let accordionId =
        index < this.items.length - 1
          ? this.items[index + 1].id
          : this.items[0].id;
      this.focusAccordion(accordionId);
    },
    getAccordionBoxIndex: function (id) {
      let index = 0;
      if (
        this.items.some((item) => {
          index = item.step - 1;
          return item.id === id;
        })
      ) {
        return index;
      }
      return 0;
    },
    focusAccordion: function (id) {
      if (id) {
        const headingId = "#" + id + "_acc_heading";
        jQuery(headingId, this.$el).first().focus();
      }
    }
  }
});
</script>
